export const CopyIcon = ({ color = "#28292B" }: { color?: string }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 19H4C2.34315 19 1 17.6569 1 16V4C1 2.34315 2.34315 1 4 1H16C17.6569 1 19 2.34315 19 4V7M10 25H22C23.6569 25 25 23.6569 25 22V10C25 8.34315 23.6569 7 22 7H10C8.34315 7 7 8.34315 7 10V22C7 23.6569 8.34315 25 10 25Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
